import HallOfMirrors from "./HallOfMirrors";

export default HallOfMirrors;
